import {getSuccessRoutePage, setSuccessRoutePage} from "@/modules/makePayment/router/middleware";

const routes = [
    {
        path: '/make-payment/:orderId?',
        component: () => import('../pages/Index.vue'),
        props:{type:'bau'}
    },
    {
        path: '/mentora/make-payment/:orderId?',
        component: () => import('../pages/Index.vue'),
        props:{type:'mentora'}
    },
    {
        path: '/housing/make-payment/:orderId?',
        component: () => import('../pages/Index.vue'),
        props:{type:'housing'}
    },
    {
        path: '/make-payment/success',
        component: () => import('../pages/Success.vue')
    },

]

export default routes
